module.exports = __webpack_public_path__ + "media/src/application/media/fond_mobile_bk-cc6ddfb5aba540c14050eea69e59d971.png";